import colores from "../../../shared/constants/styles";
import IReciboFactura from "./interface/IFilterRecibo";
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import { FormControl, Grid, TextField } from "@mui/material";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Dayjs } from "dayjs";

interface IFilterProps {
  filter: IReciboFactura;
  onSelectedFilter: (filter: IReciboFactura) => void;
  getFilterRecibo: () => void;
  clean: () => void;
}

const Filter = (props: IFilterProps) => {
  const localStorage = JSON.parse(
    window.localStorage.getItem("LocalSession") || "{}",
  );

  const [errorUI, seterrorUI] = useState({
    date: "",
    monto: "",
  });

  // ── handlers existentes ──────────────────────────────────────────────────────

  // const handleNroPedidoToChange = (event: any) => {
  //   props.onSelectedFilter({
  //     ...props.filter,
  //     nroRecibo: event.target.value,
  //   });
  // };

  const handleDateFromChange = (newDate: Dayjs | null) => {
    props.onSelectedFilter({
      ...props.filter,
      dateFrom: newDate ?? null,
    });
    seterrorUI((prev) => ({ ...prev, date: "" }));
  };

  const handleDateToChange = (newDate: Dayjs | null) => {
    props.onSelectedFilter({
      ...props.filter,
      dateTo: newDate ?? null,
    });
    seterrorUI((prev) => ({ ...prev, date: "" }));
  };

  const handleMontoDesdeChange = (event: any) => {
    const value = event.target.value;
    // Solo números y punto decimal
    if (value === "" || /^\d*\.?\d*$/.test(value)) {
      props.onSelectedFilter({
        ...props.filter,
        montoDesde: value,
      });
      seterrorUI((prev) => ({ ...prev, monto: "" }));
    }
  };

  const handleMontoHastaChange = (event: any) => {
    const value = event.target.value;
    if (value === "" || /^\d*\.?\d*$/.test(value)) {
      props.onSelectedFilter({
        ...props.filter,
        montoHasta: value,
      });
      seterrorUI((prev) => ({ ...prev, monto: "" }));
    }
  };

  const validate = (): boolean => {
    let valid = true;
    const newErrors = { date: "", monto: "" };

    // Validar fechas
    const { dateFrom, dateTo } = props.filter;

    if (dateFrom && !dateTo) {
      newErrors.date = "Ingrese la fecha Hasta.";
      valid = false;
    } else if (!dateFrom && dateTo) {
      newErrors.date = "Ingrese la fecha Desde.";
      valid = false;
    } else if (dateFrom && dateTo && dateFrom.isAfter(dateTo)) {
      newErrors.date = "La fecha Desde debe ser menor o igual a Hasta.";
      valid = false;
    }

    // Validar montos
    const montoDesde = props.filter.montoDesde ?? "";
    const montoHasta = props.filter.montoHasta ?? "";

    if (montoDesde !== "" && montoHasta === "") {
      newErrors.monto = "Ingrese el monto Hasta.";
      valid = false;
    } else if (montoDesde === "" && montoHasta !== "") {
      newErrors.monto = "Ingrese el monto Desde.";
      valid = false;
    } else if (
      montoDesde !== "" &&
      montoHasta !== "" &&
      parseFloat(montoHasta) < parseFloat(montoDesde)
    ) {
      newErrors.monto = "El monto Desde debe ser menor o igual al monto Hasta.";
      valid = false;
    }

    seterrorUI(newErrors);
    return valid;
  };

  const search = (event: any) => {
    event.preventDefault();
    if (!validate()) return;
    props.getFilterRecibo();
  };

  const handleClean = () => {
    seterrorUI({ date: "", monto: "" });
    props.onSelectedFilter({
      clienteId: localStorage.clienteId.trim(),
      dateFrom: null,
      dateTo: null,
      montoDesde: "",
      montoHasta: "",
      page: 0,
      rowPerPage: 0,
      sortField: { field: "fechaEmision", order: "DESC" },
    });
    props.clean();
  };

  useEffect(() => {}, []);

  // ── render ───────────────────────────────────────────────────────────────────

  const hasDateError = Boolean(errorUI.date);
  const hasMontoError = Boolean(errorUI.monto);

  return (
    <div className="container-fluid mx-0 px-0 w-100" style={{ margin: "2rem" }}>
      <div
        className="container-fluid"
        style={{
          backgroundColor: "white",
          width: "100%",
          overflow: "hidden",
          clear: "both",
          marginBottom: "1.85rem",
        }}
      >
        <form
          className="row row-cols-1 row-cols-sm-8 row-cols-md-8"
          onSubmit={search}
          style={{ margin: "1vw" }}
        >
          <div>
            <div className="row mb-3">
              {/* <div className="col-2">
                <FormControl fullWidth>
                  <TextField
                    id="nroRecibo"
                    value={props.filter.nroRecibo}
                    name="nroRecibo"
                    onChange={handleNroPedidoToChange}
                    label="Nro. Pedido"
                    variant="outlined"
                  />
                </FormControl>
              </div> */}

              <div className="col-3">
                <FormControl fullWidth>
                  <LocalizationProvider
                    adapterLocale="es"
                    dateAdapter={AdapterDayjs}
                  >
                    <MobileDatePicker
                      label="Desde"
                      inputFormat="DD/MM/YYYY"
                      value={props.filter.dateFrom}
                      onChange={(newValue) => handleDateFromChange(newValue)}
                      renderInput={(params) => (
                        <TextField {...params} error={hasDateError} />
                      )}
                    />
                  </LocalizationProvider>
                </FormControl>
              </div>

              <div className="col-3">
                <FormControl fullWidth>
                  <LocalizationProvider
                    adapterLocale="es"
                    dateAdapter={AdapterDayjs}
                  >
                    <MobileDatePicker
                      label="Hasta"
                      inputFormat="DD/MM/YYYY"
                      value={props.filter.dateTo}
                      onChange={(newValue) => handleDateToChange(newValue)}
                      renderInput={(params) => (
                        <TextField {...params} error={hasDateError} />
                      )}
                    />
                  </LocalizationProvider>
                </FormControl>
              </div>
            </div>

            {/* Mensaje de error de fechas */}
            {hasDateError && (
              <div className="row mb-2">
                <div className="col">
                  <span style={{ color: "red", fontSize: "0.85rem" }}>
                    {errorUI.date}
                  </span>
                </div>
              </div>
            )}

            {/* ── Fila 2: Monto Desde / Hasta ── */}
            <div className="row mb-2">
              <div className="col-2">
                <FormControl fullWidth>
                  <TextField
                    id="montoDesde"
                    value={props.filter.montoDesde ?? ""}
                    name="montoDesde"
                    onChange={handleMontoDesdeChange}
                    label="Monto Desde"
                    variant="outlined"
                    error={hasMontoError}
                    inputProps={{ inputMode: "decimal" }}
                  />
                </FormControl>
              </div>

              <div className="col-2">
                <FormControl fullWidth>
                  <TextField
                    id="montoHasta"
                    value={props.filter.montoHasta ?? ""}
                    name="montoHasta"
                    onChange={handleMontoHastaChange}
                    label="Monto Hasta"
                    variant="outlined"
                    error={hasMontoError}
                    inputProps={{ inputMode: "decimal" }}
                  />
                </FormControl>
              </div>
            </div>

            {/* Mensaje de error de montos */}
            {hasMontoError && (
              <div className="row mb-2">
                <div className="col">
                  <span style={{ color: "red", fontSize: "0.85rem" }}>
                    {errorUI.monto}
                  </span>
                </div>
              </div>
            )}
          </div>

          {/* ── Botones ── */}
          <div style={{ margin: "1vw" }}>
            <button
              type="submit"
              style={{ background: colores.rojo, color: "white" }}
              className="btn"
            >
              Buscar
            </button>
            <button
              type="button"
              style={{
                background: colores.white,
                color: "red",
                borderColor: "red",
                marginLeft: "2vh",
              }}
              className="btn"
              onClick={handleClean}
            >
              Limpiar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default connect((state: any) => ({
  loading: state.cuentacorriente.loading,
}))(Filter);
